module.exports = __webpack_public_path__ + "img/disconnected_chains.51c1db1a.svg";